import { useState, useEffect, useContext, createContext } from "react";
import { useNavigate, useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { useUserServices } from "../../../context/DealerProfile";

const PurchaseOrderContext = createContext();

export const usePurchaseOrder = () => {
  return useContext(PurchaseOrderContext);
};

export const PurchaseOrderProvider = ({ children, isReturn }) => {
  const {
    dealerDetail: {
      associatedContacts,
      billingAddresses,
      inHouseShipping,
      endCustomerShipping,
      dealerName,
      accountName,
      parentAccount,
    },
    priceItem,
  } = useUserServices();

  const navigate = useNavigate();
  const { orderId } = useParams();

  // console.log({ priceItem });

  const [openModal, setOpenModal] = useState(false);
  const [formData, setFormData] = useState({
    Dealer_Name: "",
    Delivery_Date: "",
    CP_Purchase_Owner: "",
    Date: "",
    Stage: "",
    Contact: associatedContacts?.[0]?.id,
    Orders_Items: [],
    billingAddresses: billingAddresses?.[0]?.id,
    Remark: "",
    whichTypeShipping: "in",
    inHouseShipping: inHouseShipping?.[0]?.id,
    endCustomerShipping: endCustomerShipping?.[0]?.id,
    returnReason: "Damaged",
    Request_Type: "Stock",
  });

  console.log({ billingAddresses });

  useEffect(() => {
    if (!isReturn) {
      const constructedWithSaveId = `order_${orderId}`;
      if (orderId !== "new") {
        const storedPurchase = JSON.parse(
          localStorage.getItem(constructedWithSaveId)
        );
        if (storedPurchase) {
          setFormData((oldVal) => ({ ...oldVal, ...storedPurchase }));
        } else {
          if (!orderId === "new") toast.error("No order found with this ID.");
        }
      } else {
        const storedPurchase = JSON.parse(
          localStorage.getItem("current_purchase")
        );
        if (storedPurchase) {
          setFormData((oldVal) => ({ ...oldVal, ...storedPurchase }));
        }
      }
    } else {
      (async () => {
        const toastId = toast.loading("Loading order details..."); // Start loader
        try {
          const res = await fetch(`/server/dealer_backend/order/${orderId}`);
          console.log({ res });
          if (!res.ok) {
            toast.error("Failed to fetch order details.", { id: toastId }); // Update toast to error
            throw new Error("Failed to fetch");
          }
          const data = await res.json();
          const orderData = data?.data;

          console.log({orderData});

          const billingAddress=orderData?.Billing_Address_Link;//AY
          const shippingAddress=orderData?.Shipping_Address_Link;//AY
          const shippingAddressArray=orderData?.Request_Type == "Dropship" ? "end" : "in";//AY

    // Update formData with the billing address AY
    setFormData((prevData) => ({
      ...prevData,
      
      billingAddresses: billingAddress?.id || "", 
      shippingAddresses: shippingAddress?.id || "",  
      whichTypeShipping:shippingAddressArray
    }));

          // Fetch additional details for each item asynchronously
          const itemsWithDetails = await Promise.all(
            (orderData?.Orders_Items || []).map(async (item) => {
              try {
                const itemRes = await fetch(
                  `/server/dealer_backend/item/${item.Product_Name.id}`
                );
                if (!itemRes.ok) {
                  console.warn(
                    `Failed to fetch details for item ID: ${item.Product_Name.id}`
                  );
                  return null;
                }
                const itemData = await itemRes.json();
                const itemDetails = itemData?.data;

                if (itemDetails) {
                  return {
                    id: itemDetails.id,
                    Product_Code: itemDetails.Product_Code || "",
                    Product_Name: itemDetails.Product_Name || "",
                    Quantity: item.Quantity,
                    maxQuantity: item.Quantity,
                    Unit_Price: itemDetails.Unit_Price || 0,
                    Distributors_Discount_Price:
                      (isReturn
                        ? itemDetails.Unit_Price -
                          (itemDetails.Unit_Price *
                            parentAccount?.Price_Tier2) /
                            100
                        : itemDetails.Distributors_Discount_Price) || 0,
                    // Distributors_Discount_Price:
                    //   itemDetails.Distributors_Discount_Price || 0,
                    Usage_Unit: itemDetails.Usage_Unit || "",
                    Description: itemDetails.Description || "",
                    Minimum_Order_level: itemDetails.Minimum_Order_level || 0,
                    Record_Image: itemDetails.Record_Image || "",
                    Product_Type: itemDetails.Product_Type || "",
                    Book_Id: itemDetails.Book_Id || "",
                    Sub_Category_B: itemDetails.Sub_Category_B || "",
                    Weight: itemDetails.Weight || 0,
                    Karam_No: itemDetails.Karam_No || "",
                    Dimensions: itemDetails.Dimensions || "",
                    HS_Code: itemDetails.HS_Code || "",
                  };
                }
                return null;
              } catch (error) {
                console.error(
                  `Error fetching details for item ID: ${item.Product_Name.id}`,
                  error
                );
                return null;
              }
            })
          );

          // Map and merge price information dynamically
          const detailedOrderItemsWithPrice = itemsWithDetails.map((item) => {
            if (!item) return null; // Skip null items
            const priceInfo = priceItem?.find(
              (price) => price.item_id === item.Book_Id
            );
            return {
              ...item,
              Distributors_Discount_Price:
                priceInfo?.pricebook_rate || item.Distributors_Discount_Price,
            };
          });
          // Filter out any failed item fetches
          const validItems = detailedOrderItemsWithPrice.filter(
            (item) => item !== null
          );

          // console.log({orderData});
          // Transform fetched order data into form state
          const transformedData = {
            Dealer_Name: orderData?.Dealer_Name?.name || "",
            Delivery_Date: orderData?.Delivery_Date || "",
            CP_Purchase_Owner: orderData?.Owner?.name || "",
            Date: orderData?.Created_Time || "",
            Stage: orderData?.Stage || "",
            Request_Type: orderData?.Request_Type,
            Contact: orderData?.Contact?.id || "",
            Orders_Items: validItems,
          };

          // Update the form state
          setFormData((oldVal) => ({ ...oldVal, ...transformedData }));
          toast.success("Order details loaded successfully.", { id: toastId }); // Update toast to success
        } catch (error) {
          console.error("Error fetching order details:", error);
          toast.error("Error loading order details.", { id: toastId }); // Update toast to error
        }
      })();
    }
  }, [orderId, isReturn, priceItem]);

  const handleInputChange = (name, value) => {
    setFormData((prevData) => {
      const updatedData = { ...prevData, [name]: value };
      if (!isReturn)
        localStorage.setItem("current_purchase", JSON.stringify(updatedData));
      return updatedData;
    });
  };

  const handleItemChange = (index, field, value) => {
    setFormData((prevData) => {
      const updatedItems = prevData.Orders_Items.map((item, i) =>
        i === index ? { ...item, [field]: value } : item
      );
      const updatedData = { ...prevData, Orders_Items: updatedItems };
      if (!isReturn)
        localStorage.setItem("current_purchase", JSON.stringify(updatedData));
      return updatedData;
    });
  };

  const removeItem = (index) => {
    setFormData((prevData) => {
      const updatedItems = prevData.Orders_Items.filter((_, i) => i !== index);
      const updatedData = { ...prevData, Orders_Items: updatedItems };
      if (!isReturn)
        localStorage.setItem("current_purchase", JSON.stringify(updatedData));
      return updatedData;
    });
  };

  const saveAsDraft = () => {
    const systemId = orderId !== "new" ? `order_${orderId}` : generateOrderId();
    const draftOrder = {
      ...formData,
      Grand_Total: formData.Orders_Items.reduce(
        (total, item) =>
          total + item.Quantity * item.Distributors_Discount_Price,
        0
      ).toFixed(2),
      uid: systemId,
    };
    localStorage.setItem(systemId, JSON.stringify(draftOrder));
    localStorage.removeItem("current_purchase");
    toast.success("Draft saved successfully!");
    navigate("/purchase-order");
  };

  const handleSubmit = async (e) => {
    e?.preventDefault?.();

    const today = new Date();

    if (!formData.Delivery_Date && !isReturn) {
      toast.error("Delivery Date should not be empty!");
      return;
    }

    const deliveryDate = new Date(formData.Delivery_Date);

    // Basic validations
    if (deliveryDate < today.setHours(0, 0, 0, 0) && !isReturn) {
      toast.error("Delivery date cannot be a past date!");
      return;
    }
    if (formData.Orders_Items.length === 0) {
      toast.error(
        "Please add items to your cart before creating a purchase order."
      );
      return;
    }

    // Shipping type validations
    if (formData.whichTypeShipping === "in" && !formData.inHouseShipping) {
      toast.error(
        "Channel Partner Warehouse shipping selected but no Channel Partner Warehouse shipping address provided."
      );
      return;
    } else if (
      formData.whichTypeShipping === "end" &&
      !formData.endCustomerShipping
    ) {
      toast.error(
        "End customer shipping selected but no end customer shipping address provided."
      );
      return;
    }

    // Filter and format billing and shipping addresses
    const billingAddress = billingAddresses.find(
      (addr) => addr.id === formData.billingAddresses
    );
    const shippingAddressArray =
      formData.whichTypeShipping === "in"
        ? inHouseShipping
        : endCustomerShipping;
    const shippingAddress = shippingAddressArray.find(
      (addr) =>
        addr.id ===
        (formData.whichTypeShipping === "in"
          ? formData.inHouseShipping
          : formData.endCustomerShipping)
    );

    // Validate if addresses are present
    if (!billingAddress) {
      toast.error("Billing address is missing or invalid.");
      return;
    }
    if (!shippingAddress) {
      toast.error("Shipping address is missing or invalid.");
      return;
    }

    // for Sales Return Validation
    // Validate isReturn
    if (isReturn && !formData.returnReason) {
      toast.error("Return reason should not be empty for a return.");
      return;
    }
    if (isReturn && !formData.returnDescription) {
      toast.error("Return description should not be empty for a return.");
      return;
    }

    // Prepare API payload with address details
    const apiPayload = {
      [isReturn ? "Orders_Item" : "Orders_Items"]: formData.Orders_Items.map(
        (item) => ({
          Item_Code: item.Product_Code,
          Product_Name: isReturn
            ? item.id
            : { name: item.Product_Name, id: item.id },
          Quantity: item.Quantity,
          List_Price: parseFloat((Math.round((item.Unit_Price) * 100)/100).toFixed(2)),
          // Channel_Discounted_Price: isReturn ? (item?.Unit_Price - (item?.Unit_Price * parentAccount?.Price_Tier2) / 100).toFixed(2) : item.Distributors_Discount_Price,
          Channel_Discounted_Price: parseFloat((Math.round((item.Distributors_Discount_Price) * 100)/100).toFixed(2)),
          UOM: item.Usage_Unit,
          MOQ_Remarks: item.Remarks,
          Minimum_Order_level: item.Minimum_Order_level,
          Description: item.Description,
          HS_Code: item.HS_Code,
          // Total_Value: item.Quantity * item.Distributors_Discount_Price,
        })
      ),
      Request_Type: formData.Request_Type,
      Remark: formData?.Remark,
      Parent_CP_PO: formData?.originalOrderId,
      Delivery_Date: formData.Delivery_Date,
      [isReturn ? "Channel_Partner" : "Dealer_Name"]: accountName,
      [isReturn ? "Customer" : "Contact"]: dealerName?.id && dealerName,
      Billing_Address_Link: billingAddress.id,
      Billing_City: billingAddress.City,
      Billing_Country: billingAddress.Country,
      Billing_Code: billingAddress.Postal_Code,
      Billing_State: billingAddress.State,
      Billing_Street: billingAddress.Company_Name,

      Shipping_Address_Link: shippingAddress.id,
      Shipping_City: shippingAddress.City,
      Shipping_Country: shippingAddress.Country,
      Shipping_Code: shippingAddress.Postal_Code,
      Shipping_State: shippingAddress.State,
      Shipping_Street: shippingAddress.Company_Name,
    };

    console.log({ apiPayload });
    if (isReturn) {
      apiPayload.Return_Reason = formData.returnReason;
      apiPayload.Return_Description = formData.returnDescription;
      apiPayload.CP_Purchase = orderId;
    }

    // checking if direct order is place then po number is required
    if (e?.isPOConfirm && !e?.poNumber) {
      toast.error("PO Number is required for New Order.");
      return;
    }

    if (e?.poNumber) {
      apiPayload.Customer_PO_No = e.poNumber;
      apiPayload.Stage = "New Order";
      // console.log({ apiPayload });
      // return;
    }

    //check all item quantity is greater than min order level or not 0
    const isInvalidItem = apiPayload?.Orders_Items?.some((item) => {
      return (
        item.Quantity < item.Minimum_Order_level &&
        (!item.MOQ_Remarks || item.MOQ_Remarks.trim() === "")
      );
    });

    if (isInvalidItem) {
      toast.error(
        "Remarks must be filled if quantity is less than the minimum order level."
      );
      return;
    }

    // API call
    let toastId;

    console.log({ apiPayload });
    try {
      toastId = toast.loading(
        `Creating ${isReturn ? "Sales Return" : "Purchase Order"} ....`
      );
      const response = await fetch(
        `/server/dealer_backend/${
          isReturn ? "create-sales-return" : "create-purchase-order"
        }`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(apiPayload),
        }
      );

      console.log({ response });
      if (response.ok) {
        await response.json();
        toast.success(
          `${
            isReturn ? "Sales Return" : "Purchase Order"
          } created successfully!`
        );
        if (!isReturn) {
          localStorage.removeItem(
            orderId !== "new" ? `order_${orderId}` : "current_purchase"
          );
        }
        navigate(isReturn ? `/return-history` : "/order-history", {
          replace: true,
        });
      } else {
        const errorData = await response.json();
        toast.error(
          `Error: ${
            errorData.message ||
            `Failed to create ${isReturn ? "Sales Return" : "Purchase Order"}`
          }`
        );
      }
    } catch (error) {
      toast.error(
        error.message ||
          `An error occurred while creating the ${
            isReturn ? "Sales Return" : "Purchase Order"
          }.`
      );
    } finally {
      toast.dismiss(toastId);
    }
  };

  return (
    <PurchaseOrderContext.Provider
      value={{
        formData,
        openModal,
        setOpenModal,
        handleInputChange,
        handleItemChange,
        removeItem,
        saveAsDraft,
        handleSubmit,
        setFormData,
        isReturn,
      }}
    >
      {children}
    </PurchaseOrderContext.Provider>
  );
};

const generateOrderId = () => `order_${Date.now()}`;
